import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ScriptLoaderService } from './services/script-loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'app';
  
  constructor(private scriptLoader: ScriptLoaderService) { }

  ngOnInit(): void {
    this.scriptLoader.load('app.js', 'demo.js').then(data => {
    }).catch(error => console.log(error));
    
    // if (environment.environment != "Localhost") {
    //   if (location.protocol === 'http:') {
    //     window.location.href = location.href.replace('http', 'https');
    //   }
    // }
  }
}
